const schema = () => ({
  type: "object",
  required: [],
  properties: {
    title: {
      title: "عنوان",
      type: "string",
    }
  },
});

export default schema;
